// Schedule-specific formatting + the route id parser. No DOM, no state.
import { escapeHtml } from "./format.js";
import { formatPence } from "./format.js";
import { scheduleSentence } from "../../../shared/schedule-sentence.js";

export function getScheduleIdFromPath(path) {
  const match = String(path || "").match(/^\/schedules\/([^/]+)$/);
  if (!match) return "";
  try { return decodeURIComponent(match[1]); } catch { return match[1]; }
}

// `ordinal` moved with the sentence. Re-exported because the create form's
// live preview and the list both still call it by this name.
export { ordinal } from "../../../shared/schedule-sentence.js";

export function formatFrequencyLabel(frequency) {
  switch (frequency) {
    case "weekly": return "Weekly";
    case "biweekly": return "Every 2 weeks";
    case "monthly": return "Monthly";
    case "quarterly": return "Quarterly";
    case "annually": return "Annually";
    default: return frequency || "Monthly";
  }
}

export function formatScheduleStatus(status) {
  switch (status) {
    case "draft": return "Draft";
    case "active": return "Active";
    case "paused": return "Paused";
    case "ended": return "Ended";
    case "failed": return "Failed";
    default: return status || "";
  }
}

export function scheduleStatusTagClass(status) {
  // Reuse the shared status-tag colour classes (Figma Tag 13:35, defined in
  // base.css as `.app-invoice-status-*`) — there is no separate schedule
  // palette. The previous `ar-td-status-tag-*` names were never defined, so every
  // schedule tag fell back to the bare muted-grey base (active/paused/ended all
  // looked identical). active → green, paused/failed → orange, ended/draft → grey.
  switch (status) {
    case "active": return "app-invoice-status-paid";
    case "paused": return "app-invoice-status-overdue";
    case "failed": return "app-invoice-status-overdue";
    case "ended": return "app-invoice-status-draft";
    case "draft": return "app-invoice-status-draft";
    default: return "";
  }
}

export function buildScheduleSentence(schedule) {
  // The sentence moved to `shared/schedule-sentence.js` when the phone started
  // saying it too (#624). It answers TEXT; this call site escapes it, because
  // this one builds HTML and the shared module has no business knowing that.
  return escapeHtml(scheduleSentence(schedule));
}

export function buildLiveSentence({ contactName, totalPence, frequency, startDate, endDate, maxOccurrences, dueDaysAfter, deliveryMode, currency }) {
  return buildScheduleSentence({ contactName, totalPence, frequency, startDate, endDate, maxOccurrences, dueDaysAfter, deliveryMode, currency });
}
